import React, { useEffect } from "react";

import { FaCircleXmark } from "react-icons/fa6";
import PaymentBrick from "../mercadopago/paymentBrick";

import "./courseInfo.css";

const CourseInfoModal = ({ isVisible = false, title, content, footer, onClose }) => {
  console.log("Renderizando CourseInfoModal - visible:", isVisible);

  useEffect(() => {
    if (isVisible) document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [isVisible]);
  
  if (!isVisible) return null;

  return (
    <div className="modal-info" onClick={onClose}>
      <div className="modal-info__dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <span className="modal-close" onClick={onClose}><FaCircleXmark size={24} /></span>
        </div>

        <div className="modal-content-wrapper">
          <div className="modal-course-content">
            {content}
          </div>

          <div className="modal-brick">
            <PaymentBrick
              containerId={`paymentBrick_container_${footer?.courseId || "default"}`}
              publicKey={process.env.REACT_APP_MP_PUBLIC_KEY}
              amount={footer?.price || 5000}
              userData={{
                // firstName: "Test",
                // lastName: "User",
                // email: "test_user_123456@testuser.com",
                // userId: footer?.userId || "1",
                courseId: footer?.courseId,
              }}
              selectedCourse={footer.title}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseInfoModal;
